module.exports = __webpack_public_path__ + "img/tuxsuite-logo.0b9276f4.svg";